import { Button } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const bulletedListCommand = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).toggleBulletList().run()
    : editor.chain().focus().toggleBulletList().run();

const BulletedList = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('bulletList') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<UnorderedListOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => bulletedListCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="BULLETED_LIST" defaultMessage="Bulleted list" />
        </div>
      )}
    </Button>
  );
};

export default BulletedList;
